import Contacts from 'components/About/Contacts'
import News from 'components/About/News'
import NewsEditor from 'components/About/NewsItem'
import License from 'components/Documents/License'
import Documents from 'components/Documents/Documents'
import DataForClients from 'components/About/DataForClients'
import DocumentsContainer from 'components/Documents/Index'
import InformationContainer from 'components/Information/Index'
import Departments from 'components/About/Departments'
import AllPublications from 'components/About/AllPublications'
import Publication from 'components/About/EditPublication'

import InformationContainerRoutes from './InformationContainerRoutes'

export default {
  children: [
    {
      path: 'offices',
      name: 'Contacts',
      component: Contacts
    }, {
      path: 'offices/:id',
      name: 'Office',
      component: Contacts
    }, {
      path: 'publications',
      name: 'AllPublications',
      component: AllPublications
    }, {
      path: 'publications/creator',
      name: 'PublicationCreator',
      component: Publication
    }, {
      path: 'publications/:id',
      name: 'PublicationEditor',
      component: Publication
    }, {
      path: 'documents',
      name: 'DocumentsContainer',
      component: DocumentsContainer,
      children: [
        {
          path: 'license',
          name: 'License',
          component: License
        }, {
          path: 'all',
          name: 'Documents',
          component: Documents,
          children: [
            {
              path: ':id',
              name: 'Document',
              component: Documents
            }
          ]
        }, {
          path: 'information',
          name: 'InformationContainer',
          component: InformationContainer,
          children: InformationContainerRoutes.children
        }
      ]
    }, {
      path: 'data-for-clients',
      name: 'DataForClients',
      component: DataForClients
    }, {
      path: 'news',
      name: 'News',
      component: News
    }, {
      path: 'news/creator',
      name: 'NewsCreator',
      component: NewsEditor
    }, {
      path: 'news/:id',
      name: 'NewsEditor',
      component: NewsEditor
    }, {
      path: 'Departments',
      name: 'Departments',
      component: Departments,
      children: [
        {
          path: ':id',
          name: 'Department',
          component: Departments
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/AboutRoutes.js